
'use client';

import Link from "next/link";
import styles from "@/styles/menu.module.scss";
import { Bookmark, Home, List, Settings } from "react-feather";
// import { useTranslation } from "react-i18next";
import { usePathname } from "next/navigation";
import { useTranslations } from "next-intl";

import useStore from "@store/index";
import { Container } from "react-bootstrap";
import { event } from "@lib/ga";

export default function FooterNavbar() {
  // const { t } = useTranslation();
  const currentRoute = usePathname();
  const { hasHydrated, activeOrderCount, isOnlineHold } = useStore((state) => state);

  const t = useTranslations("FooterNavbar");

  if (!hasHydrated) {
    return null; // or a loading spinner
  }

  return (
    <nav className={styles.bottomNav} style={isOnlineHold?{ display: "none" }: {}}>
      <Container>
        <Link href="/" id="footer-home-link" onClick={() => {
          event({
            action: 'navigate_home',
            category: 'engagement',
            label: 'navbar_home_clicked'
          })
        }}>
          <div className={styles.navItem + (currentRoute === "/" ? " " + styles.active : "")}>
            <Home size={24} />
            <span>{t('HOME')}</span>
          </div>
        </Link>

        <Link href="/menu/all" id="footer-menu-link" onClick={() => {
          event({
            action: 'navigate_menu',
            category: 'engagement',
            label: 'navbar_menu_clicked'
          })
        }}>
          <div className={styles.navItem + (currentRoute.includes("/menu") ? " " + styles.active : "")}>
            <List size={24} />
            <span>{t('MENU')}</span>
          </div>
        </Link>

        <Link href={"/orders"} id="footer-orders-link" onClick={() => {
          event({
            action: 'navigate_orders',
            category: 'engagement',
            label: 'navbar_orders_clicked'
          })
        }}>
          <div className={styles.navItem + (currentRoute === "/orders" ? " " + styles.active : "")}>
            {typeof activeOrderCount === "number" && activeOrderCount > 0 && <div className={styles.navItemIndicator}>{activeOrderCount > 9 ? "9+" : activeOrderCount}</div>}

            <Bookmark size={24} />
            <span>{t('ORDERS')}</span>
          </div>
        </Link>

        <Link href="/settings" id="footer-settings-link" onClick={() => {
          event({
            action: 'navigate_settings',
            category: 'engagement',
            label: 'navbar_settings_clicked'
          })
        }}>
          <div className={styles.navItem + (currentRoute === "/settings" ? " " + styles.active : "")}>
            <Settings size={24} />
            <span>{t('SETTINGS')}</span>
          </div>
        </Link>
      </Container>
    </nav>
  );
}

